export default "__VITE_ASSET__CapIwO8v__"